import {
  Breadcrumbs,
  Inline,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import { useNavigate, useParams } from 'react-router';

import { AddContractorWorkflow } from '../../../features/add-contractor-workflow';

export const ADD_CONTRACTOR_PAGE_TITLE = 'Add contractor';

export type PageParameters = {
  companyId: string;
};

export const AddContractorPage = () => {
  const { companyId } = useParams<PageParameters>();

  const navigate = useNavigate();

  return (
    <>
      <Stack gap="16">
        <Breadcrumbs
          crumbs={[
            { id: 'home', title: 'Home', onClick: () => navigate('/') },
            {
              id: 'add-contractor',
              title: ADD_CONTRACTOR_PAGE_TITLE,
              active: true,
            },
          ]}
        />
        <Inline
          justify="space-between"
          overflow="auto"
          align="center"
          minH={40}
        >
          <Typography as="h2" hideParagraphSpacing size="24" weight="medium">
            {ADD_CONTRACTOR_PAGE_TITLE}
          </Typography>
        </Inline>
      </Stack>
      <Inline justify="center">
        {companyId && <AddContractorWorkflow companyId={companyId} />}
      </Inline>
    </>
  );
};
